import { Box, Tab, Tabs } from "@mui/material";
import { Fragment, useState } from "react";
import { Heading } from "../../shared/ReusableComponents";
import RadioInput from "../../shared/ReusableComponents/RadioInput";
import {
  ManageRoleTabs,
  ManageRoleUploadCaption,
  ManageSelectValue,
} from "../../shared/constants/enums";
import AssignRoleUpload from "./ManageRole/AssignRoleUpload";
import GridandSearch from "./ManageRole/GridandSearch";

export const ManageRole = () => {
  const [selectTab, setSelectTab] = useState(ManageRoleTabs.STUDENT_TUTOR);
  const [selectRadio, setSelectRadio] = useState(ManageSelectValue.BULK);
  const [isUploadSection, setIsUploadSection] = useState<boolean>(false);

  const tabs = [
    {
      label: ManageRoleTabs.STUDENT_TUTOR,
      value: ManageRoleTabs.STUDENT_TUTOR,
    },
    { label: ManageRoleTabs.STAFF, value: ManageRoleTabs.STAFF },
  ];

  const [radioBtns, setRadioBtns] = useState([
    {
      label: "Bulk Upload",
      value: ManageSelectValue.BULK,
      disabled: false,
      isSelected: true,
    },
    {
      label: "Incremental upload",
      value: ManageSelectValue.INCREMENTAL,
      disabled: false,
      isSelected: false,
    },
  ]);

  const onChangeRadioBtn = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedRadioBtns = radioBtns.map((radio: any) => {
      return {
        ...radio,
        isSelected: radio.value === e.target.value,
      };
    });
    setRadioBtns(updatedRadioBtns);
    setSelectRadio(
      e.target.value === ManageSelectValue.BULK
        ? ManageSelectValue.BULK
        : ManageSelectValue.INCREMENTAL
    );
  };

  const onGetSelectedValue = () => {
    if (selectTab === ManageRoleTabs.STAFF) {
      return ManageSelectValue.STAFF;
    }
    return selectRadio === ManageSelectValue.BULK
      ? ManageSelectValue.BULK
      : ManageSelectValue.INCREMENTAL;
  };

  const onGetSelectedHeading = () => {
    if (selectTab === ManageRoleTabs.STAFF) {
      return "";
    }
    return selectRadio === ManageSelectValue.BULK
      ? "Bulk Upload"
      : "Incremental Upload";
  };

  const onGetSelectedCaption = () => {
    const captions = {
      [ManageRoleTabs.STAFF]: ManageRoleUploadCaption.STAFF,
      [ManageRoleTabs.STUDENT_TUTOR]:
        selectRadio === ManageSelectValue.BULK
          ? ManageRoleUploadCaption.BULK
          : ManageRoleUploadCaption.INCREMENTAL,
    };

    return captions[selectTab] || "";
  };

  return (
    <Fragment>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {isUploadSection && (
          <span
            className={`material-symbols-outlined primary-color `}
            style={{ cursor: "pointer", fontSize: "30px" }}
            onClick={() => setIsUploadSection(false)}
          >
            arrow_back
          </span>
        )}
        <Heading text="Manage Role and Permission" type="h4" isBold={true} />
      </Box>
      <Box className="manageRoleSection">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={selectTab}
            onChange={(e, value) => {
              setSelectTab(value);
              setIsUploadSection(false);
            }}
            textColor="primary"
            color="primary"
            aria-label="secondary tabs example"
          >
            {tabs &&
              tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  label={
                    <Heading
                      type={"h5"}
                      text={tab.label}
                      classes="no-case"
                      isBold={selectTab === tab.value}
                    />
                  }
                />
              ))}
          </Tabs>
        </Box>
        {!isUploadSection && (
          <Box>
            {selectTab === ManageRoleTabs.STUDENT_TUTOR && (
              <Box sx={{ padding: "10px 10px" }}>
                <RadioInput
                  values={radioBtns}
                  onChange={(e) => onChangeRadioBtn(e)}
                />
                <Box>
                  <Heading
                    text="Bulk Upload for your first upload, it replaces the full list and Incremental Upload will add to the existing list without replacing any data."
                    type="body2"
                    isBold={true}
                    classes="italic"
                  />
                </Box>
              </Box>
            )}
            <GridandSearch
              label={
                selectTab === ManageRoleTabs.STUDENT_TUTOR
                  ? ManageRoleTabs.STUDENT_TUTOR
                  : ManageRoleTabs.STAFF
              }
              selectedValue={onGetSelectedValue()}
              onAssignRoleBtn={() => setIsUploadSection(true)}
              buttonValue="Assign Role and Permission"
            />
          </Box>
        )}
        {isUploadSection && (
          <Box>
            <AssignRoleUpload
              heading={onGetSelectedHeading()}
              caption={onGetSelectedCaption()}
              selectedValue={onGetSelectedValue()}
              selectedTab={`${
                onGetSelectedValue() === ManageSelectValue.STAFF
                  ? ManageRoleTabs.STAFF
                  : ManageRoleTabs.STUDENT_TUTOR
              }`}
              onCancel={() => setIsUploadSection(false)}
            />
          </Box>
        )}
      </Box>
    </Fragment>
  );
};
